import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';
import { Select } from 'components/DesignSystem/Select';

export const RiskIndicators = ({ options, onFiltersChanged, isLoading }) => {
    const { control } = useFormContext<IFields>();

    const handleRiskIndicators = (value: readonly ISelectOption<string>[]) => {
        const isAnyRisk = value.find((i) => i.value === 'ANY_INDICATOR');
        if (isAnyRisk) {
            onFiltersChanged({ riskIndicators: [isAnyRisk] });
        } else {
            onFiltersChanged({ riskIndicators: value });
        }
    };

    return (
        <div className={classes.selectWrapper}>
            <span className={classes.title}>Risk Indicators</span>
            <Controller
                render={({ field }) => (
                    <Select<ISelectOption<string>, true>
                        id={'battlecards-filters-risk-indicators'}
                        {...field}
                        isMulti
                        options={options}
                        onChange={(newValue) => {
                            field.onChange(newValue);
                            handleRiskIndicators(newValue);
                        }}
                        isLoading={isLoading}
                    />
                )}
                name={`riskIndicators`}
                control={control}
            />
        </div>
    );
};
